/* ChatGPT Ads measurement and paid-click attribution.
 * The OpenAI SDK is deliberately deferred until after an accepted form
 * submission and after every customer field has been cleared from the DOM.
 */

(function () {
  'use strict';

  var storageKey = 'mof_ad_attribution_v1';
  var maxAgeMs = 30 * 24 * 60 * 60 * 1000;
  var pixelId = 'XVUmUzo8KdEEauqX8XMzev';
  var pixelSdkUrl = 'https://bzrcdn.openai.com/sdk/oaiq.min.js';
  var parameterNames = [
    'utm_source', 'utm_medium', 'utm_campaign', 'utm_id',
    'utm_term', 'utm_content', 'oppref',
    'oai_campaign_id', 'oai_ad_group_id', 'oai_ad_id', 'oai_ad_account_id',
    'gclid', 'wbraid', 'gbraid'
  ];

  function safeParse(value) {
    try { return JSON.parse(value); } catch (e) { return null; }
  }

  function readStore(store) {
    try {
      var value = safeParse(store.getItem(storageKey));
      if (!value) return null;
      if (!value.expires_at || Number(value.expires_at) < Date.now()) {
        store.removeItem(storageKey);
        return null;
      }
      return value;
    } catch (e) {
      return null;
    }
  }

  function writeStore(store, value) {
    try { store.setItem(storageKey, JSON.stringify(value)); } catch (e) { /* storage unavailable */ }
  }

  function readAttribution() {
    return readStore(window.sessionStorage) || readStore(window.localStorage) || {};
  }

  function sourceLane(value) {
    var source = String(value.utm_source || '').toLowerCase();
    if (
      value.oppref || value.oai_campaign_id || value.oai_ad_group_id ||
      value.oai_ad_id || value.oai_ad_account_id ||
      source === 'chatgpt' || source === 'openai'
    ) return 'chatgpt';
    if (value.gclid || value.wbraid || value.gbraid || source === 'google') return 'google';
    return 'unattributed';
  }

  function captureAttribution() {
    var query = new URLSearchParams(window.location.search || '');
    var value = {};
    var hasPaidSignal = false;

    parameterNames.forEach(function (name) {
      var raw = query.get(name);
      if (!raw) return;
      value[name] = String(raw).trim().slice(0, 500);
      hasPaidSignal = true;
    });

    if (!hasPaidSignal) return readAttribution();

    value.source_lane = sourceLane(value);
    value.landing_path = window.location.pathname;
    value.captured_at = new Date().toISOString();
    value.expires_at = Date.now() + maxAgeMs;
    writeStore(window.sessionStorage, value);
    writeStore(window.localStorage, value);
    return value;
  }

  function createEventId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }
    return 'mof-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 14);
  }

  function installPixelQueue() {
    if (!window.oaiq) {
      var q = function () { q.q.push(arguments); };
      q.q = [];
      window.oaiq = q;
      var js = document.createElement('script');
      js.async = true;
      js.src = pixelSdkUrl;
      var first = document.getElementsByTagName('script')[0];
      first.parentNode.insertBefore(js, first);
    }
    window.oaiq('init', { pixelId: pixelId });
  }

  function measureLead(eventId) {
    installPixelQueue();
    window.oaiq(
      'measure',
      'lead_created',
      { type: 'customer_action' },
      { event_id: eventId, opt_out: true }
    );
  }

  window.MOFAdAttribution = {
    get: readAttribution,
    capture: captureAttribution,
    createEventId: createEventId
  };

  window.MOFOpenAIPixel = {
    measureLead: measureLead
  };

  captureAttribution();

  function track(event) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: event });
  }

  document.addEventListener('click', function (e) {
    var el = e.target.closest ? e.target.closest('a, button') : null;
    if (!el) return;

    var tagged = el.getAttribute('data-mof-track');
    if (tagged) { track(tagged); return; }

    var href = el.getAttribute('href') || '';
    if (href.indexOf('tel:') === 0)    { track('phone_click'); return; }
    if (href.indexOf('mailto:') === 0) { track('email_click'); return; }
  }, true);
})();
